// Public nursery sites never import the authenticated dashboard or its loading UI.
const siteId = document.querySelector<HTMLMetaElement>('meta[name="poppy-public-site"]')?.content;
const match = location.pathname.match(/^(?:\/market)?\/sites\/([^/]+)(?:\/jobs(?:\/[^/]+)?)?\/?$/);
const id = siteId || match?.[1];
if (location.pathname.replace(/\/$/,'') === '/market/recruitment-test-renderer') {
  void import('./PrivateRecruitmentRenderer').then(({mountPrivateRecruitmentRenderer})=>mountPrivateRecruitmentRenderer());
} else if (id) {
  document.title = '採用情報・園のご案内';
  for (const node of document.head.querySelectorAll('link[rel*="icon"],meta[name="description"],meta[name="keywords"]')) node.remove();
  void import('./public-main').then(({ mountPublicSite }) => mountPublicSite(id)).catch(() => {
    document.getElementById('root')!.textContent = 'サイトを読み込めませんでした。再読み込みしてください。';
  });
} else {
  const startup = document.getElementById('poppy-admin-startup') as HTMLTemplateElement | null;
  if (startup) document.getElementById('root')?.append(startup.content.cloneNode(true));
  // Icon fonts are needed only by the management dashboard.
  for (const href of ['https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css', 'https://cdnjs.cloudflare.com/ajax/libs/remixicon/4.5.0/remixicon.min.css']) {
    const link = document.createElement('link'); link.rel = 'stylesheet'; link.href = href; document.head.append(link);
  }
  void import('./main');
}
